const peopleRoutes = {
    path: "/configuracoes",
    redirect: "/",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/configuracoes/whatsapp",
        name: "bot-whatsapp-list",
        component: () => import("@/views/apps/configs/whatsapp/BotWhatsAppView.vue"),
      },
                            
    ],
  };

export default peopleRoutes;